var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilestones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 6.66667C13.1617 6.66667 11.6667 5.17167 11.6667 3.33333C11.6667 1.495 13.1617 0 15 0C16.8383 0 18.3333 1.495 18.3333 3.33333C18.3333 5.17167 16.8383 6.66667 15 6.66667ZM10 12.5C8.16167 12.5 6.66667 11.005 6.66667 9.16667C6.66667 7.32833 8.16167 5.83333 10 5.83333C11.8383 5.83333 13.3333 7.32833 13.3333 9.16667C13.3333 11.005 11.8383 12.5 10 12.5ZM5 6.66667C3.16167 6.66667 1.66667 5.17167 1.66667 3.33333C1.66667 1.495 3.16167 0 5 0C6.83833 0 8.33333 1.495 8.33333 3.33333C8.33333 5.17167 6.83833 6.66667 5 6.66667ZM19.1667 18.3333H15C15 15.5758 12.7575 13.3333 10 13.3333C7.2425 13.3333 5 15.5758 5 18.3333H0.833333C0.3725 18.3333 0 18.7058 0 19.1667C0 19.6275 0.3725 20 0.833333 20H19.1667C19.6275 20 20 19.6275 20 19.1667C20 18.7058 19.6275 18.3333 19.1667 18.3333ZM0.833333 14.1667H4.80333C5.26833 13.5875 5.82833 13.09 6.45833 12.6925C5.5575 11.7875 5 10.5417 5 9.16667C5 8.88333 5.02917 8.6075 5.075 8.3375C5.05 8.3375 5.02583 8.33333 5 8.33333C2.2425 8.33333 0 10.5758 0 13.3333C0 13.7942 0.3725 14.1667 0.833333 14.1667ZM20 13.3333C20 10.5758 17.7575 8.33333 15 8.33333C14.975 8.33333 14.9508 8.33667 14.925 8.3375C14.9708 8.60833 15 8.88417 15 9.16667C15 10.5417 14.4425 11.7875 13.5417 12.6925C14.1717 13.09 14.7317 13.5875 15.1967 14.1667H19.1667C19.6275 14.1667 20 13.7942 20 13.3333Z",
    fill: "url(#paint0_linear_381_41)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_41",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestones);
export default __webpack_public_path__ + "static/media/milestones.7791642e9932107c907e8d54256a2d48.svg";
export { ForwardRef as ReactComponent };